import { call, put, takeLatest } from "redux-saga/effects";
import { sagaActions } from "./sagaActions";
import { callGetAPI } from "../API";
import { SERVER_API } from "../../helper/Constants";

function* logoutUser(action) {
  try {
    const userData = yield call(() => callGetAPI(SERVER_API.USER_LOGOUT));
    yield put({ type: sagaActions.USER_LOGOUT, data: userData });
  } catch (e) {
    yield put({ type: sagaActions.USER_LOGOUT_FAILED, message: e.message });
  }
}

function* watchUserLogoutAsync() {
  yield takeLatest(sagaActions.USER_LOGOUT_REQUEST, logoutUser);
}

export default watchUserLogoutAsync;
